// eslint-disable-next-line no-restricted-imports
import { JiraEntitlementAri } from '@atlassian/ari';

export const getEntitlementIdFromAri = (maybeAri: string): string =>
	JiraEntitlementAri.check(maybeAri) ? JiraEntitlementAri.parse(maybeAri).entitlementId : maybeAri;
